module.exports = __webpack_public_path__ + "static/profile1-0e4cfee717280605efc51902c4cd80c2.png";